import { Button, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import Activity from "../../../../models/Activity";
import { Cardinality } from "../../../../models/Cardinality";
import { Proposal } from "../../../../models/Proposal";
import User from "../../../../models/User";
import { Close, PlaylistAdd } from '@mui/icons-material';
import { getsimulationActivityIcon } from "../tableActivitiesUtils";
import { useTranslation } from "react-i18next";


type TargetTableRowProps = {
    row: Cardinality;
    rowIndex: number;
    tableRowIndex: number;
    proposals: Proposal[];
    optionsSourceProposal: any[]; //hacer console log
    optionsTargetProposal: any[]; //hacer console log
    incompleteProposals: any[]; //hacer console log
    equivalencyMode: string;
    user: User;


    handleClickOnUncheckActivity: (activity: Activity) => void;
    handleDeleteProposal: (proposal: Proposal) => void;

    setSelectedSourceProposal: (value: any) => void;
    setSelectedTargetProposal: (value: any) => void;
    setMinContent: (value: any) => void;
    setSourceLabelAutocomplete: (value: string) => void;
    setTargetLabelAutocomplete: (value: string) => void;
    setIsDisabledSourceProposal: (value: boolean) => void;
    setIsProposalEditionId: (value: any) => void;
    setOpen: (value: boolean) => void;
};

const TargetTableRow = ({
    row,
    rowIndex,
    tableRowIndex,
    proposals,
    optionsSourceProposal,
    optionsTargetProposal,
    incompleteProposals,
    equivalencyMode,
    user,
    handleClickOnUncheckActivity,
    handleDeleteProposal,
    setSelectedSourceProposal,
    setSelectedTargetProposal,
    setMinContent,
    setSourceLabelAutocomplete,
    setTargetLabelAutocomplete,
    setIsDisabledSourceProposal,
    setIsProposalEditionId,
    setOpen,
}: TargetTableRowProps) => {
    const { t } = useTranslation();
    const sourceActivity = row.source_activities[rowIndex];
    const targetActivity = row.target_activities[rowIndex];

    const proposalId = row.proposal?.proposalId;

    const optionSourceProposalOfRow = optionsSourceProposal.find(
        (o) => o.originalId === sourceActivity?.id
    );

    const backgroundColor = tableRowIndex % 2 === 0 ? "#FFF" : "#efefef !important";
    
    let tooltipButtonTitle = '';
    if (equivalencyMode === 'internal') {
        tooltipButtonTitle = t('cantAddProposalInternal');
    } else if (optionsSourceProposal.length === 0) {
        tooltipButtonTitle = t('cantAddProposal');
    } else {
        tooltipButtonTitle = t('addProposal');
    }

    const handleRowClick = () => {
        const proposal = proposals.find((p) => p.proposalId === proposalId);
        if (!proposal) return;

        setSelectedSourceProposal(
        optionsSourceProposal.find(
            (o) => o.id === proposal.sourceStudentActivityId
        ) ?? null
        );

        setSelectedTargetProposal(
        optionsTargetProposal.find((o) => o.id === proposal.targetActivityId) ??
            null
        );

        setMinContent(
        proposal.proposalMinContentSelected?.minContentSelected ?? []
        );

        setSourceLabelAutocomplete(
        optionsSourceProposal.find(
            (o) => o.id === proposal.sourceStudentActivityId
        )?.name ?? ""
        );

        setTargetLabelAutocomplete(
        optionsTargetProposal.find((o) => o.id === proposal.targetActivityId)
            ?.name ?? ""
        );

        setIsDisabledSourceProposal(true);
        setIsProposalEditionId(proposalId ?? null);
        setOpen(true);
    };

    const handleAddSuggestion = () => {
        const existing = incompleteProposals.find(
        (incompleteProposal) => incompleteProposal.selectedSourceProposal.id === optionSourceProposalOfRow?.id
        );

        if (existing) {
        setSelectedSourceProposal(existing.selectedSourceProposal);
        setSelectedTargetProposal(existing.selectedTargetProposal);
        setMinContent(existing.minContent);
        setSourceLabelAutocomplete(existing.sourceLabelAutocomplete);
        setTargetLabelAutocomplete(existing.targetLabelAutocomplete);
        } else {
        setSelectedSourceProposal(optionSourceProposalOfRow ?? null);
        }

        if (optionSourceProposalOfRow) {
        setIsDisabledSourceProposal(true);
        }

        setOpen(true);
    };

    const renderActivity = (activity: Activity | null, isSource: boolean) => {
        if (!activity) return null;

        return (
        <div style={{ display: "flex" }}>
            <p>{activity.name}</p>

            {isSource && !user?.valid && (
            <Tooltip placement='top' arrow title={t("uncheckActivityTooltip")}>
                <IconButton sx={{ cursor: 'pointer' }} size="small">
                <Close
                    color="error"
                    data-testid="error-button"
                    onClick={(e) => {
                    e.stopPropagation();
                    handleClickOnUncheckActivity(activity);
                    }}
                    sx={{ maxWidth: "20px", maxHeight: "20px" }}
                />
                </IconButton>
            </Tooltip>
            )}
        </div>
        );
    };


    return (
        <TableRow onClick={handleRowClick} sx={{ position: "relative" }}>
            <TableCell sx={{ backgroundColor, border: "none" }}>
                {rowIndex < row.source_activities.length && renderActivity(sourceActivity, true)}
            </TableCell>

            <TableCell sx={{ backgroundColor, border: "none" }}>
                {targetActivity ? (
                    <div>
                        {renderActivity(targetActivity, false)}
                    </div> //ver si hace falta
                ) : (<div style={{ height: '40px' }}>
                    {row.state === "WARNING" ? (
                    <Tooltip placement='top' arrow title={tooltipButtonTitle}>
                        <Button
                            data-testid="add-suggestions"
                            variant="outlined"
                            color='primary'
                            onClick={(e) => {
                            e.stopPropagation();
                            handleAddSuggestion();
                            }}
                            disabled={
                            optionsSourceProposal.length === 0 ||
                            equivalencyMode === "internal"
                            }
                        >
                            <PlaylistAdd />
                        </Button>
                    </Tooltip>
                    ) : null
                    }
                    </div>
                )}
            </TableCell>

            <TableCell align="center" scope="row" sx={{ backgroundColor, border: "none" }}>
                {row.target_activities[rowIndex] || row.target_activities.length === 0 ? (
                    <div>{getsimulationActivityIcon(row.state, t, user?.valid)}</div>
                ) : (
                    <div style={{ height: '40px' }}></div>
                )}
            </TableCell>

            {row.proposal && (
                <Tooltip placement='top' arrow title={t("deleteProposal")} >
                <IconButton
                    sx={{ position: "absolute", right: 0, top: 0 }}
                    size="small"
                >
                    <Close
                    color="error"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (row.proposal) {
                            handleDeleteProposal(row.proposal)
                        }
                    }}
                    />
                </IconButton>
                </Tooltip>
            )}
        </TableRow>
    );
};

export default TargetTableRow